import { CSSObject } from '@emotion/react'
import {
  Spacing,
  Typography,
  ThemedColors,
  gemVar,
  CornerRadius,
} from '@opallabs/gem'

const LIST_WIDTH = '100%'
const LIST_MAX_HEIGHT = 174

const listPadding = Spacing.M + Spacing.XS

type ContainerStyleProps = {
  hideCollaborators: boolean
  listLength: number
  maxVisibleList?: number
  styleOverrides?: CSSObject
}

const collaboratorList = ({
  hideCollaborators,
  longList,
}: {
  hideCollaborators: boolean
  longList: boolean
}): CSSObject => ({
  blockSize: hideCollaborators ? '100%' : LIST_MAX_HEIGHT,
  display: 'flex',
  flexFlow: 'column nowrap',
  listStyle: 'none',
  margin: 0,
  marginBlockStart: hideCollaborators ? 0 : Spacing.XS * 5,
  overflow: 'auto',
  padding: 0,
  paddingBlockEnd: !hideCollaborators && longList ? listPadding : 0,
  paddingInlineEnd: listPadding,
  rowGap: Spacing.S,
})

export const container = ({
  hideCollaborators,
  listLength,
  maxVisibleList,
  styleOverrides,
}: ContainerStyleProps): CSSObject => ({
  backgroundColor: gemVar(ThemedColors.Surface1),
  border: `solid 1px ${gemVar(ThemedColors.StrokeSecondary1)}`,
  borderRadius: CornerRadius.Large,
  inlineSize: LIST_WIDTH,
  padding: `${listPadding}px 0 0 ${listPadding}px`,
  paddingBlockEnd:
    hideCollaborators || (maxVisibleList && listLength < maxVisibleList)
      ? (styleOverrides?.paddingBottom ?? listPadding)
      : 0,

  '.satellite-searchable-user-list': {
    marginInlineEnd: listPadding,
  },

  '.selected-collaborator-list': collaboratorList({
    hideCollaborators,
    longList: listLength > 3,
  }),
})

export const labelWrapper: CSSObject = {
  alignItems: 'baseline',
  display: 'flex',
  columnGap: Spacing.XS,
}

export const label: CSSObject = {
  marginBlockEnd: Spacing.XS,
}

export const count: CSSObject = {
  ...Typography.T500,
  color: gemVar(ThemedColors.TextSecondary),
}

export const noCollaboratorsText: CSSObject = {
  ...Typography.T500,
  color: gemVar(ThemedColors.TextSecondary),
  inlineSize: '100%',
  padding: `0 ${Spacing.M}px`,
  textAlign: 'center',
}

export const helpText: CSSObject = {
  ...Typography.T300,
  color: gemVar(ThemedColors.TextSecondary),
}
